module.exports = __webpack_public_path__ + "img/img19.7399c44c.svg";